module.exports = __webpack_public_path__ + "img/user-full.988db51b.png";